import React from 'react';
import clsx from 'clsx';
import useStyles from '../../../Playoff.styles';
import PlayoffParticipant from '../../../components/PlayoffParticipant';
import ModifiedPlayoffPlayer from '../../../../../../../../models/pages/tournament/playoff/ModifiedPlayoffPlayer';
import RoundResult from '../../../../../../../../models/pages/tournament/playoff/RoundResult';

function SemiFinalCard(props: {
  player: ModifiedPlayoffPlayer | null;
  setParticipant: React.Dispatch<React.SetStateAction<RoundResult>>;
  winnerId: number | null | undefined;
  isEditMode: boolean;
}) {
  const classes = useStyles();
  const { player, setParticipant, winnerId, isEditMode } = props;
  return (
    <div
      className={clsx(classes.flexRow, classes.anglerContainer, classes.shortContainer, {
        [classes.subWinner]: player?.id === winnerId,
      })}
    >
      <PlayoffParticipant winnerId={winnerId} player={player} setParticipant={setParticipant} isEditMode={isEditMode} />
    </div>
  );
}

export default SemiFinalCard;
